import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import IconWithText from 'components/Widgets/IconWithText';

import NewModal from './NewModal';
import Archive from './Archive';

export default function Index() {
  const [assessments, setAssessments] = useState(null);
  const [showNewModal, setShowNewModal] = useState(false);

  useEffect(() => {
    axios
      .get(routes.api.members.assessments.index)
      .then((response) => {
        setAssessments(response.data.data);
      });
  }, []);

  return (
    <section>
      <h4 className="mb-4">External Assessments</h4>

      <Row>
        <Col sm={9} lg={10}>
          <IconWithText
            iconClassName="certified-icon big-icon bg-secondary"
            contentClassName="mb-3 mb-sm-0"
            wrapperClassName="align-items-start"
          >
            <>
              <p>
                Uploading external assessments to LeggUP offers your coach key insights into
                {' '}
                your progress, enabling more tailored and effective coaching.
              </p>

              {assessments === null ? (
                <LoadingPlaceholder />
              ) : (
                <Archive
                  assessments={assessments}
                  setAssessments={setAssessments}
                />
              )}
            </>
          </IconWithText>
        </Col>

        <Col sm={3} lg={2}>
          <Button
            onClick={() => setShowNewModal(true)}
            className={`w-sm-100 px-3 px-sm-0 ${assessments === null ? 'disabled' : ''}`}
          >
            Upload
          </Button>

          <NewModal
            show={showNewModal}
            assessments={assessments}
            setAssessments={setAssessments}
            onCloseClick={(afterSubmit = () => {}) => {
              setShowNewModal(false);
              afterSubmit();
            }}
          />
        </Col>
      </Row>
    </section>
  );
}
